import { CategorySelectFormikField } from '../../../../../Category'
import { FieldStackedLabel } from '../../../../../Field'

import * as styles from '../../../ConnectedRequestsMassEditModal.module.css'

function CategoryValueField({ label, name, placeholder }) {
  return (
    <CategorySelectFormikField
      Field={FieldStackedLabel}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder,
          },
        },
      }}
      fieldComponentProps={{
        className: styles.valueFieldStackedLabel,
        label,
      }}
      name={name}
    />
  )
}

export default CategoryValueField
